// extracted by mini-css-extract-plugin
export default {"wrapper":"Description_wrapper__yNPOq","medium":"Description_medium__i4oiO","large":"Description_large__DOroY"};